import { render } from "./CreateCurrency.vue?vue&type=template&id=7d40aa56"
import script from "./CreateCurrency.vue?vue&type=script&lang=js"
export * from "./CreateCurrency.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__